import { Sites } from '@ps/platform-message-framework/common/Sites';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { ExclusionTime } from '../../shared/definitions';

import {
  TXTWCL_Can_I_remove_or_change_my_self_ELL,
  TXTWCL_Can_I_still_access_my_accountX,
  TXTWCL_Can_I_still_access_my_account__ELL,
  TXTWCL_Can_I_still_access_my_account__ELL_1,
  TXTWCL_Can_this_be_undoneX,
  TXTWCL_Cool_off_periods_and_Indefinit_ELL,
  TXTWCL_DonXt_worryX_weXll_automatical_ELL,
  TXTWCL_For_anything_over_N0_daysX_you_ELL,
  TXTWCL_For_breaks_up_to_180_daysX_we__ELL,
  TXTWCL_For_indefinite_self_exclusions_ELL,
  TXTWCL_For_permanent_self_exclusionsX_ELL,
  TXTWCL_How_can_I_manage_my_spendingX,
  TXTWCL_How_long_can_I_take_a_break_fo_ELL,
  TXTWCL_HoweverX_if_youXve_chosen_inde_ELL,
  TXTWCL_HoweverX_you_wonXt_be_able_to__ELL,
  TXTWCL_HoweverX_you_wonXt_be_able_to__ELL_1,
  TXTWCL_However_you_will_still_be_able_ELL,
  TXTWCL_If_youXre_not_sure_about_takin_ELL,
  TXTWCL_If_youXve_opted_for_standard_s_ELL,
  TXTWCL_If_you_choose_to_permanently_s_ELL,
  TXTWCL_If_you_have_chosen_to_cool_off_ELL,
  TXTWCL_If_you_have_chosen_to_indefini_ELL_1,
  TXTWCL_If_you_have_chosen_to_take_a_b_ELL,
  TXTWCL_If_you_select_a_cool_off_perio_ELL,
  TXTWCL_If_you_select_a_short_break_or_ELL,
  TXTWCL_If_you_would_like_to_end_your__ELL,
  TXTWCL_MoreoverX_you_will_be_automati_ELL,
  TXTWCL_NoX_2,
  TXTWCL_No_you_cannotX,
  TXTWCL_Once_youXve_decided_to_take_a__ELL,
  TXTWCL_Once_you_have_confirmed_your_e_ELL,
  TXTWCL_Our_customer_services_team_wil_ELL,
  TXTWCL_Self_exclusion_cannot_be_remov_ELL,
  TXTWCL_The_XTransfer_FundsX_option_wi_ELL,
  TXTWCL_UnfortunatelyX_we_canXt_extend_ELL,
  TXTWCL_Unfortunately_notX_Once_youXve_ELL,
  TXTWCL_Unfortunately_we_canXt_extend__ELL,
  TXTWCL_We_also_wonXt_send_you_any_new_ELL,
  TXTWCL_We_would_strongly_advise_you_t_ELL,
  TXTWCL_What_about_bonusesX,
  TXTWCL_What_happens_to_my_funds_durin_ELL,
  TXTWCL_What_if_IXve_signed_up_to_tour_ELL,
  TXTWCL_When_your_break_endsX_we_will__ELL,
  TXTWCL_When_your_break_endsX_we_will__ELL_1,
  TXTWCL_When_your_break_endsX_you_will_ELL,
  TXTWCL_XbXWhat_happens_when_my_break__ELL,
  TXTWCL_YesX_for_anything_less_than_N0_ELL,
  TXTWCL_Yes_you_canX_But_you_wonXt_be__ELL,
  TXTWCL_Yes_you_canX_HoweverX_you_wonX_ELL,
  TXTWCL_You_can_choose_between_3_month_ELL,
  TXTWCL_You_wonXt_receive_any_newslett_ELL
} from './useExclusionInfoMessages.messages.json';

const useExclusionInfoMessages = () => {
  const site = useSelector(select.cms.getSiteId);

  switch (true) {
    case site === Sites.DE:
      return [
        {
          infoQuestion: TXTWCL_How_long_can_I_take_a_break_fo_ELL,
          infoAnswer: { tag: TXTWCL_You_can_choose_between_3_month_ELL }
        },
        {
          infoQuestion: TXTWCL_XbXWhat_happens_when_my_break__ELL,
          infoAnswer: { tag: TXTWCL_When_your_break_endsX_you_will_ELL }
        },
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: [
            { tag: TXTWCL_NoX_2 },
            { tag: TXTWCL_Once_youXve_decided_to_take_a__ELL },
            { tag: TXTWCL_Our_customer_services_team_wil_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: [
            { tag: TXTWCL_Yes_you_canX_HoweverX_you_wonX_ELL },
            { tag: TXTWCL_You_wonXt_receive_any_newslett_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_UnfortunatelyX_we_canXt_extend_ELL }
        },
        {
          infoQuestion: TXTWCL_What_if_IXve_signed_up_to_tour_ELL,
          infoAnswer: { tag: TXTWCL_DonXt_worryX_weXll_automatical_ELL }
        }
      ];
    case site === Sites.UK:
      return [
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: { tag: TXTWCL_Unfortunately_notX_Once_youXve_ELL }
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: [
            {
              tag: TXTWCL_YesX_for_anything_less_than_N0_ELL,
              values: { 0: ExclusionTime.HundredEightyDays }
            },
            { tag: TXTWCL_HoweverX_you_wonXt_be_able_to__ELL },
            { tag: TXTWCL_We_also_wonXt_send_you_any_new_ELL },
            {
              tag: TXTWCL_For_anything_over_N0_daysX_you_ELL,
              values: { 0: ExclusionTime.HundredEightyDays }
            }
          ]
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_Unfortunately_we_canXt_extend__ELL }
        },
        {
          infoQuestion: TXTWCL_What_if_IXve_signed_up_to_tour_ELL,
          infoAnswer: { tag: TXTWCL_DonXt_worryX_weXll_automatical_ELL }
        },
        {
          infoQuestion: TXTWCL_How_can_I_manage_my_spendingX,
          infoAnswer: { tag: TXTWCL_If_youXre_not_sure_about_takin_ELL }
        }
      ];
    case site === Sites.CA_ON:
      return [
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: { tag: TXTWCL_Unfortunately_notX_Once_youXve_ELL }
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_account__ELL,
          infoAnswer: { tag: TXTWCL_Yes_you_canX_But_you_wonXt_be__ELL }
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_account__ELL_1,
          infoAnswer: [
            { tag: TXTWCL_No_you_cannotX },
            { tag: TXTWCL_MoreoverX_you_will_be_automati_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_Unfortunately_we_canXt_extend__ELL }
        },
        {
          infoQuestion: TXTWCL_What_if_IXve_signed_up_to_tour_ELL,
          infoAnswer: { tag: TXTWCL_DonXt_worryX_weXll_automatical_ELL }
        },
        {
          infoQuestion: TXTWCL_How_can_I_manage_my_spendingX,
          infoAnswer: { tag: TXTWCL_If_youXre_not_sure_about_takin_ELL }
        }
      ];
    case site === Sites.FRA:
      return [
        {
          infoQuestion: TXTWCL_XbXWhat_happens_when_my_break__ELL,
          infoAnswer: { tag: TXTWCL_When_your_break_endsX_we_will__ELL }
        },
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: [
            { tag: TXTWCL_NoX_2 },
            { tag: TXTWCL_Once_youXve_decided_to_take_a__ELL },
            { tag: TXTWCL_Our_customer_services_team_wil_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: [
            { tag: TXTWCL_Yes_you_canX_HoweverX_you_wonX_ELL },
            { tag: TXTWCL_You_wonXt_receive_any_newslett_ELL },
            { tag: TXTWCL_The_XTransfer_FundsX_option_wi_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_UnfortunatelyX_we_canXt_extend_ELL }
        }
      ];

    case site === Sites.GR:
      return [
        {
          infoQuestion: TXTWCL_XbXWhat_happens_when_my_break__ELL,
          infoAnswer: { tag: TXTWCL_When_your_break_endsX_we_will__ELL_1 }
        },
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: [
            { tag: TXTWCL_NoX_2 },
            { tag: TXTWCL_Once_youXve_decided_to_take_a__ELL },
            { tag: TXTWCL_Our_customer_services_team_wil_ELL },
            { tag: TXTWCL_If_you_choose_to_permanently_s_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: [
            { tag: TXTWCL_Yes_you_canX_HoweverX_you_wonX_ELL },
            { tag: TXTWCL_You_wonXt_receive_any_newslett_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_UnfortunatelyX_we_canXt_extend_ELL }
        }
      ];
    case site === Sites.US_PA:
      return [
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: [
            { tag: TXTWCL_NoX_2 },
            { tag: TXTWCL_Once_youXve_decided_to_take_a__ELL },
            { tag: TXTWCL_Our_customer_services_team_wil_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: [
            { tag: TXTWCL_Yes_you_canX_HoweverX_you_wonX_ELL },
            { tag: TXTWCL_You_wonXt_receive_any_newslett_ELL },
            { tag: TXTWCL_The_XTransfer_FundsX_option_wi_ELL },
            { tag: TXTWCL_However_you_will_still_be_able_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_UnfortunatelyX_we_canXt_extend_ELL }
        }
      ];

    case site === Sites.US_NJ:
      return [
        {
          infoQuestion: TXTWCL_XbXWhat_happens_when_my_break__ELL,
          infoAnswer: { tag: TXTWCL_For_breaks_up_to_180_daysX_we__ELL }
        },
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: [
            { tag: TXTWCL_NoX_2 },
            { tag: TXTWCL_Once_youXve_decided_to_take_a__ELL },
            { tag: TXTWCL_Our_customer_services_team_wil_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: [
            { tag: TXTWCL_Yes_you_canX_HoweverX_you_wonX_ELL },
            { tag: TXTWCL_You_wonXt_receive_any_newslett_ELL },
            { tag: TXTWCL_The_XTransfer_FundsX_option_wi_ELL },
            { tag: TXTWCL_However_you_will_still_be_able_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_UnfortunatelyX_we_canXt_extend_ELL }
        }
      ];
    case site === Sites.USMI:
      return [
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: { tag: TXTWCL_Unfortunately_notX_Once_youXve_ELL }
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: [
            { tag: TXTWCL_Yes_you_canX_But_you_wonXt_be__ELL },
            { tag: TXTWCL_However_you_will_still_be_able_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_Unfortunately_we_canXt_extend__ELL }
        },
        {
          infoQuestion: TXTWCL_What_if_IXve_signed_up_to_tour_ELL,
          infoAnswer: { tag: TXTWCL_DonXt_worryX_weXll_automatical_ELL }
        },
        {
          infoQuestion: TXTWCL_How_can_I_manage_my_spendingX,
          infoAnswer: { tag: TXTWCL_If_youXre_not_sure_about_takin_ELL }
        }
      ];
    case site === Sites.POR:
      return [
        {
          infoQuestion: TXTWCL_XbXWhat_happens_when_my_break__ELL,
          infoAnswer: [
            { tag: TXTWCL_If_you_select_a_cool_off_perio_ELL },
            { tag: TXTWCL_For_indefinite_self_exclusions_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: [
            { tag: TXTWCL_Cool_off_periods_and_Indefinit_ELL },
            { tag: TXTWCL_If_you_would_like_to_end_your__ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: [
            { tag: TXTWCL_If_you_have_chosen_to_cool_off_ELL },
            { tag: TXTWCL_HoweverX_you_wonXt_be_able_to__ELL_1 },
            { tag: TXTWCL_You_wonXt_receive_any_newslett_ELL },
            { tag: TXTWCL_If_you_have_chosen_to_indefini_ELL_1 }
          ]
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_UnfortunatelyX_we_canXt_extend_ELL }
        }
      ];
    case site === Sites.DEN:
      return [
        {
          infoQuestion: TXTWCL_XbXWhat_happens_when_my_break__ELL,
          infoAnswer: [
            { tag: TXTWCL_If_you_select_a_short_break_or_ELL },
            { tag: TXTWCL_For_permanent_self_exclusionsX_ELL }
          ]
        },
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: { tag: TXTWCL_Once_you_have_confirmed_your_e_ELL }
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: [
            { tag: TXTWCL_If_you_have_chosen_to_take_a_b_ELL },
            { tag: TXTWCL_HoweverX_you_wonXt_be_able_to__ELL_1 },
            { tag: TXTWCL_You_wonXt_receive_any_newslett_ELL },
            { tag: TXTWCL_If_you_have_chosen_to_indefini_ELL_1 }
          ]
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_UnfortunatelyX_we_canXt_extend_ELL }
        }
      ];
    case site === Sites.BEL:
      return [
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: { tag: TXTWCL_Unfortunately_notX_Once_youXve_ELL }
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: { tag: TXTWCL_Yes_you_canX_But_you_wonXt_be__ELL }
        },
        {
          infoQuestion: TXTWCL_What_if_IXve_signed_up_to_tour_ELL,
          infoAnswer: { tag: TXTWCL_DonXt_worryX_weXll_automatical_ELL }
        },
        {
          infoQuestion: TXTWCL_How_can_I_manage_my_spendingX,
          infoAnswer: { tag: TXTWCL_If_youXre_not_sure_about_takin_ELL }
        }
      ];
    case site === Sites.COM:
      return [
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: { tag: TXTWCL_Unfortunately_notX_Once_youXve_ELL }
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: { tag: TXTWCL_Yes_you_canX_But_you_wonXt_be__ELL }
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_Unfortunately_we_canXt_extend__ELL }
        },
        {
          infoQuestion: TXTWCL_What_if_IXve_signed_up_to_tour_ELL,
          infoAnswer: { tag: TXTWCL_DonXt_worryX_weXll_automatical_ELL }
        },
        {
          infoQuestion: TXTWCL_How_can_I_manage_my_spendingX,
          infoAnswer: { tag: TXTWCL_If_youXre_not_sure_about_takin_ELL }
        },
        {
          infoQuestion: TXTWCL_Can_I_remove_or_change_my_self_ELL,
          infoAnswer: { tag: TXTWCL_Self_exclusion_cannot_be_remov_ELL }
        }
      ];
    case site === Sites.SWE:
      return [
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: { tag: TXTWCL_Unfortunately_notX_Once_youXve_ELL }
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: [
            { tag: TXTWCL_If_youXve_opted_for_standard_s_ELL },
            {
              tag: TXTWCL_HoweverX_if_youXve_chosen_inde_ELL,
              values: { 0: ExclusionTime.TwelveMonths }
            }
          ]
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_Unfortunately_we_canXt_extend__ELL }
        },
        {
          infoQuestion: TXTWCL_What_if_IXve_signed_up_to_tour_ELL,
          infoAnswer: { tag: TXTWCL_DonXt_worryX_weXll_automatical_ELL }
        },
        {
          infoQuestion: TXTWCL_How_can_I_manage_my_spendingX,
          infoAnswer: { tag: TXTWCL_If_youXre_not_sure_about_takin_ELL }
        },
        {
          infoQuestion: TXTWCL_What_happens_to_my_funds_durin_ELL,
          infoAnswer: { tag: TXTWCL_We_would_strongly_advise_you_t_ELL, values: { 0: 5 } }
        }
      ];
    default:
      return [
        {
          infoQuestion: TXTWCL_Can_this_be_undoneX,
          infoAnswer: { tag: TXTWCL_Unfortunately_notX_Once_youXve_ELL }
        },
        {
          infoQuestion: TXTWCL_Can_I_still_access_my_accountX,
          infoAnswer: { tag: TXTWCL_Yes_you_canX_But_you_wonXt_be__ELL }
        },
        {
          infoQuestion: TXTWCL_What_about_bonusesX,
          infoAnswer: { tag: TXTWCL_Unfortunately_we_canXt_extend__ELL }
        },
        {
          infoQuestion: TXTWCL_What_if_IXve_signed_up_to_tour_ELL,
          infoAnswer: { tag: TXTWCL_DonXt_worryX_weXll_automatical_ELL }
        },
        {
          infoQuestion: TXTWCL_How_can_I_manage_my_spendingX,
          infoAnswer: { tag: TXTWCL_If_youXre_not_sure_about_takin_ELL }
        }
      ];
  }
};

export default useExclusionInfoMessages;
